import React from "react";

const Wedding5th = () => {
  return (
    <div className="wedding_page5_img">
      <div className="wedding5bg">
        <div className="wedding5-container">
          <div>
            <h1 className="wedding5header">OUR MENU</h1>
            <div>
              <img
                className="wedding5heading-img"
                src="./Assets/experience-logo.webp"
                alt="img"
              ></img>
            </div>
          </div>
          <div className="wedding5textcontainer">
            <div className="wedding5text">
              <p>Lorem ipsum dolor sit </p>

              <p className="viewpdf">View PDF</p>
            </div>
            <div className="wedding5text">
              <p>Lorem ipsum dolor sit </p>

              <p className="viewpdf">View PDF</p>
            </div>
            <div className="wedding5text">
              <p>Lorem ipsum dolor sit </p>

              <p className="viewpdf">View PDF</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Wedding5th;
